import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { defaultPhoneFormatter } from './utils';
import { handleDynamicCalltracking } from '../..';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Кнопка с поддержкой ДКТ, сразу показывающая телефон без попапа.
 */
export var DynamicCalltrackingButton = function DynamicCalltrackingButton(_ref) {
  var announcementId = _ref.announcementId,
    blockId = _ref.blockId,
    _ref$buttonFullWidth = _ref.buttonFullWidth,
    buttonFullWidth = _ref$buttonFullWidth === void 0 ? false : _ref$buttonFullWidth,
    _ref$buttonSize = _ref.buttonSize,
    buttonSize = _ref$buttonSize === void 0 ? 'M' : _ref$buttonSize,
    buttonText = _ref.buttonText,
    buttonTheme = _ref.buttonTheme,
    httpApi = _ref.httpApi,
    isOpen = _ref.isOpen,
    logger = _ref.logger,
    onClick = _ref.onClick,
    openPhoneClassName = _ref.openPhoneClassName,
    pageType = _ref.pageType,
    phone = _ref.phone,
    _ref$phoneFormatter = _ref.phoneFormatter,
    phoneFormatter = _ref$phoneFormatter === void 0 ? defaultPhoneFormatter : _ref$phoneFormatter,
    platformType = _ref.platformType,
    placeType = _ref.placeType,
    queryString = _ref.queryString;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dynamicPhone = _React$useState2[0],
    setDynamicPhone = _React$useState2[1];
  var handleClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var dynamicPhone, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dynamicPhone = null;
            if (!blockId) {
              _context.next = 6;
              break;
            }
            _context.next = 4;
            return handleDynamicCalltracking({
              logger: logger,
              httpApi: httpApi,
              blockId: blockId,
              platformType: platformType,
              pageType: pageType,
              placeType: placeType,
              announcementId: announcementId,
              queryString: queryString
            });
          case 4:
            response = _context.sent;
            dynamicPhone = phoneFormatter(response.notFormattedPhone, response.phone);
          case 6:
            if (onClick) {
              onClick(e);
            }
            setDynamicPhone(dynamicPhone || phone);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (isOpen) {
    return /*#__PURE__*/_jsx("span", {
      className: openPhoneClassName,
      children: dynamicPhone
    });
  }
  return /*#__PURE__*/_jsx(Button, {
    fullWidth: buttonFullWidth,
    size: buttonSize,
    theme: buttonTheme,
    onClick: handleClick,
    children: buttonText
  });
};